import React from "react";
import { Router, Route, Switch } from "react-router-dom";
import {
  ForemanProfile,
  Calender,
  PaymentRequests,
  PaymentHistory,
  AboutUs,
  CompanyRequests,
  RequestDetails,
  AddAddress,
  EditAddress,
  EditRequestExtraItems,
  EditRequestItems,
  Chats,
  SignAgreement,
  EditProfile,
  HowAllowLocation,
} from "../pages";

function Routes(props) {
  return (
    <Switch>
      <Route exact path="/foreman" component={ForemanProfile} />
      <Route exact path="/foreman/edit-profile" component={EditProfile} />
      <Route path="/foreman/calender" component={Calender} />
      <Route
        exact
        path="/foreman/foreman-requests"
        component={CompanyRequests}
      />
      <Route
        exact
        path="/foreman/foreman-requests/:requestId"
        component={RequestDetails}
      />
      <Route
        exact
        path="/foreman/foreman-requests/add-address/:requestId"
        component={AddAddress}
      />
      <Route
        exact
        path="/foreman/foreman-requests/edit-address/:requestId/:addressId"
        component={EditAddress}
      />
      <Route
        exact
        path="/foreman/foreman-requests/edit-items/:requestId"
        component={EditRequestItems}
      />
      <Route
        exact
        path="/foreman/foreman-requests/edit-extra-items/:requestId"
        component={EditRequestExtraItems}
      />
      <Route path="/foreman/chats" component={Chats} />
      <Route path="/foreman/about-us" component={AboutUs} />
      <Route path="/foreman/how-allow-location" component={HowAllowLocation} />

      <Route
        path="/foreman/foreman-requests/sign-agreement/:requestId"
        component={SignAgreement}
      />
    </Switch>
  );
}

export default Routes;
